<div *ngIf="points">
  <div *ngFor="let point of points" (click)="selectInspectionPoint(point)">
    <span>{{ point.name }}</span>
  </div>
</div>
